import React from "react";
import PropTypes from "prop-types";

export default function HamburgerMenu(props) {
    const w = props.width || 32;
  const width = `${w}px`,
    height = `${props.height || 20}px`,
    halfHeight = `${parseInt(height.replace("px", "")) / 2}px`,
    isOpen = props.isOpen || false,
    strokeWidth = props.strokeWidth || 4,
    halfStrokeWidth = `-${strokeWidth / 2}px`,
    animationDuration = props.animationDuration || "0.4";

  const getTransformValue = (isOpen, defaultPos, rotateVal) =>
    `translate3d(0,${isOpen ? halfHeight : defaultPos},0) rotate(${
      isOpen ? `${rotateVal}deg` : "0"
    })`;

  const styles = {
    container: {
      width,
      height,
      position: "relative",
      transform: `rotate(${props.rotate || 0}deg)`,
      margin:`${16}px`,
      display:`inline-block`
    },
    lineBase: {
      display: "block",
      height: `${strokeWidth}px`,
      width: w,
      background: props.color || "auto",
      transitionTimingFunction: "ease",
      transitionDuration: `${animationDuration}s`,
      borderRadius: `${props.borderRadius || 2}px`,
      transformOrigin: "center",
      position: "absolute"
    },
    firstLine: {
      transform: getTransformValue(isOpen, 0, 45),
      marginTop: halfStrokeWidth
    },
    secondLine: {
      transitionTimingFunction: "ease-out",
      transitionDuration: `${animationDuration / 4}s`,
      opacity: isOpen ? "0" : "1",
      top: halfHeight,
      marginLeft: w*0,
      marginTop: halfStrokeWidth,
      width:w,
      //width:w*0.7,
    },
    thirdLine: {
      transform: getTransformValue(isOpen, height, -45),
      marginTop: halfStrokeWidth
    }
  };


  return (
    <div
      style={styles.container}
      className={props.className}
      onClick={props.menuClicked}>
      <span className="line" style={Object.assign({}, styles.lineBase, styles.firstLine)}></span>
      <span  className="line" style={Object.assign({}, styles.lineBase, styles.secondLine)}></span>
      <span  className="line" style={Object.assign({}, styles.lineBase, styles.thirdLine)}></span>
    </div>

  );
}

HamburgerMenu.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  menuClicked: PropTypes.func.isRequired,
  width: PropTypes.number,
  height: PropTypes.number,
  strokeWidth: PropTypes.number,
  rotate: PropTypes.number,
  color: PropTypes.string,
  borderRadius: PropTypes.number,
  animationDuration: PropTypes.number,
	className: PropTypes.string,
};